(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tk-club-anime"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (!('customElements' in window) || customElements.get('tk-shop-by-anime')) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    class TkShopByAnime extends HTMLElement {
      connectedCallback() {
        this._cleanups = [];
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._init.bind(this), { once: true });
        } else {
          this._init();
        }
      }

      disconnectedCallback() {
        this._destroy();
      }

      _init() {
        if (this._ready || !this.isConnected) return;
        this._ready = true;

        var root = this;
        var cleanups = this._cleanups;
        var reduced = REDUCED.matches;
        var scroller = root.querySelector('[data-tk-scroller]');
        var prev = root.querySelector('[data-tk-prev]');
        var next = root.querySelector('[data-tk-next]');

        /* ---------- Setas do carrossel ---------- */
        if (scroller && prev && next) {
          var update = function () {
            var max = scroller.scrollWidth - scroller.clientWidth;
            var scrollable = max > 4;
            prev.hidden = !scrollable;
            next.hidden = !scrollable;
            if (!scrollable) return;
            prev.disabled = scroller.scrollLeft <= 2;
            next.disabled = scroller.scrollLeft >= max - 2;
          };
          var step = function (dir) {
            var item = scroller.querySelector('.tk-sba__item');
            var track = scroller.firstElementChild;
            var gap = track ? parseFloat(window.getComputedStyle(track).columnGap) || 24 : 24;
            var dist = item ? (item.offsetWidth + gap) * 2 : scroller.clientWidth * 0.8;
            scroller.scrollBy({ left: dir * dist, behavior: reduced ? 'auto' : 'smooth' });
          };
          var onPrev = function () { step(-1); };
          var onNext = function () { step(1); };
          var raf = null;
          var schedule = function () {
            if (raf) return;
            raf = window.requestAnimationFrame(function () { raf = null; update(); });
          };

          prev.addEventListener('click', onPrev);
          next.addEventListener('click', onNext);
          scroller.addEventListener('scroll', schedule, { passive: true });
          window.addEventListener('resize', schedule);
          window.addEventListener('load', schedule, { once: true });
          update();

          cleanups.push(function () {
            prev.removeEventListener('click', onPrev);
            next.removeEventListener('click', onNext);
            scroller.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
            window.removeEventListener('load', schedule);
            if (raf) window.cancelAnimationFrame(raf);
          });
        }

        /* ---------- Animação de entrada ----------
           O CSS já deixou header/itens ocultos (html.js + data-animate).
           Aqui só marcamos "in" quando a seção aparece na tela — uma vez.
           Sem IntersectionObserver ou com "reduzir movimento", revela
           na hora. O observer é desconectado no primeiro disparo e no
           disconnectedCallback (editor), então nunca duplica. */
        if (root.dataset.animate === 'enabled' && root.getAttribute('data-anim-state') !== 'in') {
          if (reduced || !('IntersectionObserver' in window)) {
            root.setAttribute('data-anim-state', 'in');
          } else {
            var io = new IntersectionObserver(function (entries) {
              for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                  root.setAttribute('data-anim-state', 'in');
                  io.disconnect();
                  break;
                }
              }
            }, { threshold: 0.1 });
            io.observe(root);
            cleanups.push(function () { io.disconnect(); });
          }
        }

        /* ---------- Editor do tema: bloco selecionado -> centraliza ---------- */
        if (scroller && window.Shopify && window.Shopify.designMode) {
          var onBlockSelect = function (e) {
            if (!e.target || !e.target.contains(root)) return;
            var id = e.detail && e.detail.blockId;
            var el = id ? root.querySelector('[data-block-id="' + id + '"]') : null;
            if (!el) return;
            var sRect = scroller.getBoundingClientRect();
            var eRect = el.getBoundingClientRect();
            var left = scroller.scrollLeft + (eRect.left - sRect.left) - (sRect.width - eRect.width) / 2;
            scroller.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
          };
          document.addEventListener('shopify:block:select', onBlockSelect);
          cleanups.push(function () {
            document.removeEventListener('shopify:block:select', onBlockSelect);
          });
        }
      }

      _destroy() {
        var cleanups = this._cleanups || [];
        for (var i = 0; i < cleanups.length; i++) cleanups[i]();
        this._cleanups = [];
        this._ready = false;
      }
    }

    customElements.define('tk-shop-by-anime', TkShopByAnime);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tk-discovery-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tk-discovery-tabs')) {
    customElements.define(
      'tk-discovery-tabs',
      class TkDiscoveryTabs extends HTMLElement {
        connectedCallback() {
          if (this.controller) this.controller.abort();
          this.controller = new AbortController();
          const signal = this.controller.signal;
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.rows = Array.from(this.querySelectorAll('[data-tk-row]'));

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.select(tab), { signal });
            tab.addEventListener('keydown', (event) => {
              const last = this.tabs.length - 1;
              const target = { ArrowRight: index === last ? 0 : index + 1, ArrowLeft: index === 0 ? last : index - 1, Home: 0, End: last }[event.key];
              if (target === undefined) return;
              event.preventDefault();
              this.select(this.tabs[target], true);
            }, { signal });
          });

          this.tablist = this.querySelector('.tk-disc__tablist');
          this.rows.forEach((row) => this.initRow(row, signal));
          window.addEventListener('resize', () => { this.updateRows(); this.movePill(false); }, { signal, passive: true });
          if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.movePill(false));
          this.movePill(false);

          if (this.hasAttribute('data-animate')) this.initAnimation();

          if (window.Shopify && window.Shopify.designMode) {
            document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
          }
        }

        disconnectedCallback() {
          if (this.controller) this.controller.abort();
          if (this.observer) this.observer.disconnect();
        }

        select(tab, focus = false) {
          this.tabs.forEach((item) => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
            const panel = this.querySelector('#' + item.getAttribute('aria-controls'));
            if (panel) panel.hidden = !active;
          });
          const category = tab.dataset.tkCategory;
          this.querySelectorAll('[data-tk-desc]').forEach((desc) => {
            desc.hidden = desc.dataset.tkDesc !== category;
          });
          if (focus) tab.focus();
          this.movePill(true);
          this.updateRows();
        }

        movePill(animate) {
          const list = this.tablist;
          const tab = list && list.querySelector('[aria-selected="true"]');
          if (!tab || !tab.offsetWidth) return;
          list.classList.toggle('is-measuring', !animate);
          list.style.setProperty('--tk-ind-left', tab.offsetLeft + 'px');
          list.style.setProperty('--tk-ind-width', tab.offsetWidth + 'px');
          list.classList.add('is-ready');
          if (!animate) requestAnimationFrame(() => list.classList.remove('is-measuring'));
        }

        initRow(row, signal) {
          const scroller = row.querySelector('[data-tk-scroller]');
          const prev = row.querySelector('[data-tk-prev]');
          const next = row.querySelector('[data-tk-next]');
          if (!scroller || !prev || !next) return;
          const step = (direction) => {
            const item = scroller.querySelector('.tk-disc__item');
            if (!item) return;
            const gap = parseFloat(getComputedStyle(item.parentElement).columnGap) || 0;
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            scroller.scrollBy({ left: direction * (item.offsetWidth + gap) * 3, behavior: reduce ? 'auto' : 'smooth' });
          };
          prev.addEventListener('click', () => step(-1), { signal });
          next.addEventListener('click', () => step(1), { signal });
          scroller.addEventListener('scroll', () => this.updateRows(), { signal, passive: true });
          this.updateRow(row);
        }

        updateRow(row) {
          const scroller = row.querySelector('[data-tk-scroller]');
          const prev = row.querySelector('[data-tk-prev]');
          const next = row.querySelector('[data-tk-next]');
          if (!scroller || !prev || !next) return;
          const max = scroller.scrollWidth - scroller.clientWidth;
          const scrollable = max > 4;
          prev.hidden = !scrollable;
          next.hidden = !scrollable;
          if (!scrollable) return;
          prev.disabled = scroller.scrollLeft <= 2;
          next.disabled = scroller.scrollLeft >= max - 2;
        }

        updateRows() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.rows.forEach((row) => this.updateRow(row));
          });
        }

        initAnimation() {
          if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.setAttribute('data-anim-state', 'in');
            return;
          }
          this.observer = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.setAttribute('data-anim-state', 'in');
            this.observer.disconnect();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        }

        onBlockSelect(event) {
          const item = this.querySelector('[data-block-id="' + (event.detail && event.detail.blockId) + '"]');
          if (!item) return;
          const panel = item.closest('[role="tabpanel"]');
          const tab = panel && this.querySelector('[aria-controls="' + panel.id + '"]');
          if (tab) this.select(tab);
          item.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tokyo-shop-by-anime"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (!('customElements' in window) || customElements.get('tk-shop-by-anime')) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

    class TkShopByAnime extends HTMLElement {
      connectedCallback() {
        this._cleanups = [];
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._init.bind(this), { once: true });
        } else {
          this._init();
        }
      }

      disconnectedCallback() {
        this._destroy();
      }

      _init() {
        if (this._ready || !this.isConnected) return;
        this._ready = true;

        var root = this;
        var cleanups = this._cleanups;
        var reduced = REDUCED.matches;
        var scroller = root.querySelector('[data-tk-scroller]');
        var prev = root.querySelector('[data-tk-prev]');
        var next = root.querySelector('[data-tk-next]');

        /* ---------- Setas do carrossel ---------- */
        if (scroller && prev && next) {
          var update = function () {
            var max = scroller.scrollWidth - scroller.clientWidth;
            var scrollable = max > 4;
            prev.hidden = !scrollable;
            next.hidden = !scrollable;
            if (!scrollable) return;
            prev.disabled = scroller.scrollLeft <= 2;
            next.disabled = scroller.scrollLeft >= max - 2;
          };
          var step = function (dir) {
            var item = scroller.querySelector('.tk-sba__item');
            var track = scroller.firstElementChild;
            var gap = track ? parseFloat(window.getComputedStyle(track).columnGap) || 24 : 24;
            var dist = item ? (item.offsetWidth + gap) * 2 : scroller.clientWidth * 0.8;
            scroller.scrollBy({ left: dir * dist, behavior: reduced ? 'auto' : 'smooth' });
          };
          var onPrev = function () { step(-1); };
          var onNext = function () { step(1); };
          var raf = null;
          var schedule = function () {
            if (raf) return;
            raf = window.requestAnimationFrame(function () { raf = null; update(); });
          };

          prev.addEventListener('click', onPrev);
          next.addEventListener('click', onNext);
          scroller.addEventListener('scroll', schedule, { passive: true });
          window.addEventListener('resize', schedule);
          window.addEventListener('load', schedule, { once: true });
          update();

          cleanups.push(function () {
            prev.removeEventListener('click', onPrev);
            next.removeEventListener('click', onNext);
            scroller.removeEventListener('scroll', schedule);
            window.removeEventListener('resize', schedule);
            window.removeEventListener('load', schedule);
            if (raf) window.cancelAnimationFrame(raf);
          });
        }

        /* ---------- Animação de entrada ----------
           O CSS já deixou header/itens ocultos (html.js + data-animate).
           Aqui só marcamos "in" quando a seção aparece na tela — uma vez.
           Sem IntersectionObserver ou com "reduzir movimento", revela
           na hora. O observer é desconectado no primeiro disparo e no
           disconnectedCallback (editor), então nunca duplica. */
        if (root.dataset.animate === 'enabled' && root.getAttribute('data-anim-state') !== 'in') {
          if (reduced || !('IntersectionObserver' in window)) {
            root.setAttribute('data-anim-state', 'in');
          } else {
            var io = new IntersectionObserver(function (entries) {
              for (var i = 0; i < entries.length; i++) {
                if (entries[i].isIntersecting) {
                  root.setAttribute('data-anim-state', 'in');
                  io.disconnect();
                  break;
                }
              }
            }, { threshold: 0.1 });
            io.observe(root);
            cleanups.push(function () { io.disconnect(); });
          }
        }

        /* ---------- Editor do tema: bloco selecionado -> centraliza ---------- */
        if (scroller && window.Shopify && window.Shopify.designMode) {
          var onBlockSelect = function (e) {
            if (!e.target || !e.target.contains(root)) return;
            var id = e.detail && e.detail.blockId;
            var el = id ? root.querySelector('[data-block-id="' + id + '"]') : null;
            if (!el) return;
            var sRect = scroller.getBoundingClientRect();
            var eRect = el.getBoundingClientRect();
            var left = scroller.scrollLeft + (eRect.left - sRect.left) - (sRect.width - eRect.width) / 2;
            scroller.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' });
          };
          document.addEventListener('shopify:block:select', onBlockSelect);
          cleanups.push(function () {
            document.removeEventListener('shopify:block:select', onBlockSelect);
          });
        }
      }

      _destroy() {
        var cleanups = this._cleanups || [];
        for (var i = 0; i < cleanups.length; i++) cleanups[i]();
        this._cleanups = [];
        this._ready = false;
      }
    }

    customElements.define('tk-shop-by-anime', TkShopByAnime);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (!('customElements' in window) || customElements.get('tk-community-gallery')) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    class TkCommunityGallery extends HTMLElement {
      connectedCallback() {
        this._cleanups = [];
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._init.bind(this), { once: true });
        } else {
          this._init();
        }
      }

      disconnectedCallback() {
        this._destroy();
      }

      _init() {
        if (this._ready || !this.isConnected) return;
        this._ready = true;
        this.sectionId = this.dataset.sectionId || '';
        this.designMode = !!(window.Shopify && window.Shopify.designMode);
        this._initSlider();
        this._initLightbox();
        this._initEditor();
      }

      /* ---------- Carrossel: setas + posição vertical das setas ---------- */
      _initSlider() {
        var root = this;
        var track = root.querySelector('[data-tk-track]');
        if (!track) return;
        root.track = track;

        var nav = root.querySelector('[data-tk-nav]');
        var prev = root.querySelector('[data-tk-prev]');
        var next = root.querySelector('[data-tk-next]');
        var raf = null;

        var update = function () {
          var media = track.querySelector('[data-tk-media]');
          if (media) root.style.setProperty('--tk-media-h', media.offsetHeight + 'px');
          if (!nav) return;
          var max = track.scrollWidth - track.clientWidth;
          var scrollable = max > 4;
          nav.hidden = !scrollable;
          if (prev) prev.disabled = !scrollable || track.scrollLeft <= 2;
          if (next) next.disabled = !scrollable || track.scrollLeft >= max - 2;
        };
        var schedule = function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () { raf = null; update(); });
        };
        var stepSize = function () {
          var card = track.querySelector('[data-tk-card]');
          var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
          return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        };
        var step = function (dir) {
          track.scrollBy({ left: dir * stepSize(), behavior: REDUCED.matches ? 'auto' : 'smooth' });
        };
        var onPrev = function () { step(-1); };
        var onNext = function () { step(1); };

        if (prev) prev.addEventListener('click', onPrev);
        if (next) next.addEventListener('click', onNext);
        track.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);

        var ro = null;
        if ('ResizeObserver' in window) {
          ro = new ResizeObserver(schedule);
          ro.observe(track);
        }
        update();

        this._cleanups.push(function () {
          if (prev) prev.removeEventListener('click', onPrev);
          if (next) next.removeEventListener('click', onNext);
          track.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
          if (ro) ro.disconnect();
          if (raf) window.cancelAnimationFrame(raf);
        });
      }

      /* ---------- Lightbox ---------- */
      _initLightbox() {
        var root = this;
        var dialog = root.querySelector('[data-tk-lightbox]');
        if (!dialog) return;

        var inner = dialog.querySelector('[data-tk-lightbox-inner]');
        var img = dialog.querySelector('[data-tk-lightbox-img]');
        var caption = dialog.querySelector('[data-tk-lightbox-caption]');
        var closeBtn = dialog.querySelector('[data-tk-close]');
        var supportsDialog = typeof HTMLDialogElement === 'function' && typeof dialog.showModal === 'function';
        var isOpen = false;
        var lastFocus = null;

        var onKeydown = function (e) {
          if (!isOpen) return;
          if (e.key === 'Escape' || e.key === 'Esc') {
            e.preventDefault();
            close();
            return;
          }
          if (e.key !== 'Tab') return;
          var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
            return el.offsetParent !== null || el === closeBtn;
          });
          if (!items.length) { e.preventDefault(); return; }
          var first = items[0];
          var last = items[items.length - 1];
          if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
            e.preventDefault();
            first.focus();
          }
        };

        var open = function (trigger) {
          if (isOpen) return;
          isOpen = true;
          lastFocus = trigger;

          var d = trigger.dataset;
          if (d.tkW) img.width = parseInt(d.tkW, 10) || 1200;
          if (d.tkH) img.height = parseInt(d.tkH, 10) || 1500;
          img.alt = d.tkAlt || '';
          img.sizes = '100vw';
          if (d.tkSrcset) img.srcset = d.tkSrcset;
          img.src = d.tkSrc;
          dialog.setAttribute('aria-label', d.tkAlt || dialog.getAttribute('aria-label') || '');

          /* Legenda: selo (se houver) + informações do card (clonadas) */
          caption.textContent = '';
          if (d.tkBadge) {
            var badge = document.createElement('span');
            badge.className = 'tk-community__badge';
            var dot = document.createElement('span');
            dot.className = 'tk-community__badge-dot';
            dot.setAttribute('aria-hidden', 'true');
            badge.appendChild(dot);
            badge.appendChild(document.createTextNode(d.tkBadge));
            caption.appendChild(badge);
          }
          var card = trigger.closest('[data-tk-card]');
          var meta = card ? card.querySelector('[data-tk-meta]') : null;
          if (meta) {
            Array.prototype.forEach.call(meta.children, function (child) {
              if (child.classList.contains('tk-community__badge')) return;
              caption.appendChild(child.cloneNode(true));
            });
          }
          caption.hidden = caption.childElementCount === 0;

          if (supportsDialog) {
            if (!dialog.open) dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
          root._lockScroll(inner);
          document.addEventListener('keydown', onKeydown, true);
          closeBtn.focus();
        };

        var close = function () {
          if (!isOpen) return;
          isOpen = false;
          document.removeEventListener('keydown', onKeydown, true);
          if (supportsDialog) {
            if (dialog.open) dialog.close();
          } else {
            dialog.removeAttribute('open');
          }
          root._unlockScroll();
          img.removeAttribute('src');
          img.removeAttribute('srcset');
          if (lastFocus && lastFocus.isConnected) lastFocus.focus();
          lastFocus = null;
        };

        var onZoomClick = function (e) {
          var trigger = e.target.closest('[data-tk-zoom]');
          if (!trigger || !root.contains(trigger)) return;
          /* No editor do tema, o clique do mouse fica livre para
             selecionar o bloco; a ampliação abre pelo teclado (Enter). */
          if (root.designMode && e.detail !== 0) return;
          e.preventDefault();
          open(trigger);
        };
        var onDialogClick = function (e) {
          /* Clique fora do conteúdo (fundo) fecha */
          if (e.target === dialog || e.target === inner) close();
        };
        var onCancel = function (e) {
          e.preventDefault();
          close();
        };

        root.addEventListener('click', onZoomClick);
        dialog.addEventListener('click', onDialogClick);
        dialog.addEventListener('cancel', onCancel);
        closeBtn.addEventListener('click', close);

        this._closeLightbox = close;
        this._cleanups.push(function () {
          close();
          root.removeEventListener('click', onZoomClick);
          dialog.removeEventListener('click', onDialogClick);
          dialog.removeEventListener('cancel', onCancel);
          closeBtn.removeEventListener('click', close);
        });
      }

      /* ---------- Bloqueio de rolagem (mecanismo do Broadcast + fallback) ---------- */
      _lockScroll(scrollable) {
        if (this._locked) return;
        this._locked = true;
        if (window.theme) {
          document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: scrollable }));
        } else {
          this._prevOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }
      }

      _unlockScroll() {
        if (!this._locked) return;
        this._locked = false;
        if (window.theme) {
          document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
        } else {
          document.documentElement.style.overflow = this._prevOverflow || '';
        }
      }

      /* ---------- Editor do tema: bloco selecionado -> rola até o card ---------- */
      _initEditor() {
        if (!this.designMode) return;
        var root = this;
        var onBlockSelect = function (e) {
          if (!e.target || !e.target.contains(root) || !root.track) return;
          var id = e.detail && e.detail.blockId;
          var card = id ? root.querySelector('[data-block-id="' + id + '"]') : null;
          if (!card) return;
          var tRect = root.track.getBoundingClientRect();
          var cRect = card.getBoundingClientRect();
          var padLeft = parseFloat(window.getComputedStyle(root.track).paddingLeft) || 0;
          root.track.scrollTo({
            left: root.track.scrollLeft + (cRect.left - tRect.left) - padLeft,
            behavior: REDUCED.matches ? 'auto' : 'smooth'
          });
        };
        document.addEventListener('shopify:block:select', onBlockSelect);
        this._cleanups.push(function () {
          document.removeEventListener('shopify:block:select', onBlockSelect);
        });
      }

      _destroy() {
        var cleanups = this._cleanups || [];
        for (var i = 0; i < cleanups.length; i++) cleanups[i]();
        this._cleanups = [];
        this._ready = false;
        this.track = null;
      }
    }

    customElements.define('tk-community-gallery', TkCommunityGallery);
  })();

  } catch(e) { console.error(e); }
})();
})();
